import React, { useState, useRef, useEffect } from "react";
import { STATIC_KEYWORDS } from "../../../constants";
import "./newsletterWidget.m.css";
import { useSelector } from "react-redux";
import get from "lodash/get";

const NewsletterWidget = (props) => {
  const { data: { magazineWidget = {} } = {} } = props;

  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const qtConfig = useSelector((state) => get(state, ["qt", "config"], {}));
  const isWebView = get(qtConfig, ["isWebView"]) === true;

  const inputRef = useRef(null);
  const { emagazineMainContainerBgImageUrl = "" } = magazineWidget;

  const formatName = (namePart) => {
    if (!namePart) return "";
    return namePart.charAt(0).toUpperCase() + namePart.slice(1).toLowerCase();
  };

  const getNamesFromEmail = (email) => {
    const localPart = email.split("@")[0];
    const parts = localPart.split(/[._-]/);
    const firstName = formatName(parts[0]);
    const lastName = formatName(parts[1]);
    return { firstName, lastName };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmedEmail = email.trim();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    if (!trimmedEmail || !emailRegex.test(trimmedEmail)) {
      setError(STATIC_KEYWORDS.INVALID_EMAIL_ERROR);
      setTimeout(() => setError(null), 3000);
      return;
    }

    const { firstName, lastName } = getNamesFromEmail(trimmedEmail);
    setIsLoading(true);

    try {
      const response = await fetch("/newsletter-api/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: trimmedEmail, firstName, lastName }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.message || STATIC_KEYWORDS.GENERIC_ERROR_MESSAGE);
      }

      setEmail("");

      if (data.message === "New member subscribed") {
        setSuccess(STATIC_KEYWORDS.SUBSCRIPTION_SUCCESS_MESSAGE);
      } else if (data.message === "You have already subscribed") {
        setSuccess(STATIC_KEYWORDS.ALREADY_SUBSCRIBED_MESSAGE);
      } else {
        setSuccess(data.message);
      }

      setTimeout(() => setSuccess(null), 3000);
    } catch (err) {
      setError(err.message);
      setTimeout(() => setError(null), 3000);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!inputRef.current) return;
    const input = inputRef.current;

    const resizeFont = () => {
      let fontSize = 16;
      input.style.fontSize = `${fontSize}px`;

      while (input.scrollWidth > input.clientWidth && fontSize > 10) {
        fontSize -= 1;
        input.style.fontSize = `${fontSize}px`;
      }
    };

    resizeFont();
  }, [email]);

  if (isWebView) return null;

  return (
    <div styleName="newsletterWidget-container">
      <div
        // style={{
        //   backgroundImage: `url(${emagazineMainContainerBgImageUrl})`,
        // }}
        styleName="newsletterWidget-emailwidget newsletterWidget-background"
      >
        <span styleName="newsletterWidget-image"></span>

        <div styleName="newsletterWidget-content">
          <div styleName="newsletterWidget-heading">{STATIC_KEYWORDS.NEWSLETTER_HEADING}</div>

          <form onSubmit={handleSubmit}>
            <div styleName="newsletterWidget-form-group">
              <label styleName="newsletterWidget-label">{STATIC_KEYWORDS.EMAIL_LABEL}</label>
              <div styleName="newsletterWidget-input-wrapper">
                <input
                  type="email"
                  styleName="newsletterWidget-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={isLoading}
                  required
                  ref={inputRef}
                  placeholder={STATIC_KEYWORDS.EMAIL_PLACEHOLDER}
                />
                <button
                  type="submit"
                  styleName="newsletterWidget-button"
                  disabled={isLoading}
                  aria-label={STATIC_KEYWORDS.SUBSCRIBE}
                >
                  {isLoading ? STATIC_KEYWORDS.SUBSCRIBING : STATIC_KEYWORDS.SUBSCRIBE}
                </button>
              </div>

              {error && <div styleName="newsletterWidget-error">{error}</div>}
              {success && <div styleName="newsletterWidget-success">{success}</div>}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewsletterWidget;
